<template>
  <div class="company_info">
    <div class="content">
      <h2 class="left-border">
        {{ $t('company-detail.company-info', { split: '/' }) }}
      </h2>

      <div class="widget-company-info">
        <ul>
          <li
            v-if="
              companyInfoDetail !== null &&
              companyInfoDetail.industry_type !== null
            "
          >
            <span class="title-bold">
              {{
                $t('company-detail.title.company-information.industry-type', {
                  split: '/'
                })
              }}:
            </span>
            {{
              industryTypeFormat(
                companyInfoDetail !== null
                  ? companyInfoDetail.industry_type
                  : ''
              )
            }}
          </li>

          <li
            v-if="
              companyInfoDetail !== null &&
              companyInfoDetail.business_content !== null
            "
          >
            <span class="title-bold">
              {{
                $t(
                  'company-detail.title.company-information.business-content',
                  { split: '/' }
                )
              }}:
            </span>

            <div
              class="td-right"
              v-html="
                companyInfoDetail !== null
                  ? companyInfoDetail.business_content
                  : ''
              "
            ></div>
          </li>

          <li
            v-if="
              companyInfoDetail !== null &&
              companyInfoDetail.head_office_address !== null
            "
          >
            <span class="title-bold">
              {{
                $t('company-detail.title.company-information.head-office', {
                  split: '/'
                })
              }}:
            </span>
            {{
              companyInfoDetail !== null
                ? companyInfoDetail.head_office_address
                : ''
            }}
          </li>

          <li
            v-if="
              companyInfoDetail !== null &&
              companyInfoDetail.established !== null
            "
          >
            <span class="title-bold">
              {{
                $t('company-detail.title.company-information.established', {
                  split: '/'
                })
              }}:
            </span>
            {{
              convertDateTime(
                companyInfoDetail !== null ? companyInfoDetail.established : ''
              )
            }}
          </li>

          <li
            v-if="
              companyInfoDetail !== null &&
              companyInfoDetail.representative !== null
            "
          >
            <span class="title-bold">
              {{
                $t('company-detail.title.company-information.representative', {
                  split: '/'
                })
              }}:
            </span>
            {{
              companyInfoDetail !== null ? companyInfoDetail.representative : ''
            }}
          </li>

          <li
            v-if="
              companyInfoDetail !== null && companyInfoDetail.capital !== null
            "
          >
            <span class="title-bold">
              {{
                $t('company-detail.title.company-information.capital', {
                  split: '/'
                })
              }}:
            </span>
            {{ companyInfoDetail !== null ? companyInfoDetail.capital : '' }}
          </li>

          <li
            v-if="
              companyInfoDetail !== null &&
              companyInfoDetail.annual_sales !== null
            "
          >
            <span class="title-bold">
              {{
                $t('company-detail.title.company-information.annual-sales', {
                  split: '/'
                })
              }}:
            </span>
            {{
              companyInfoDetail !== null ? companyInfoDetail.annual_sales : ''
            }}
          </li>

          <!-- <li
            v-if="
              companyInfoDetail !== null &&
                companyInfoDetail.employee_total !== null
            "
          >
            <span class="title-bold">
              {{
                $t('company-detail.title.company-information.employee-total', {
                  split: '/'
                })
              }}:
            </span>
            {{
              companyInfoDetail !== null
                ? companyInfoDetail.employee_total +
                  ' ' +
                  $t(computedPerson(companyInfoDetail.employee_total), {
                    split: '/'
                  })
                : ''
            }}
          </li> -->

          <li
            v-if="
              companyInfoDetail !== null &&
              companyInfoDetail.employee_text !== null
            "
          >
            <span class="title-bold">
              {{
                $t('company-detail.title.company-information.employee-text', {
                  split: '/'
                })
              }}:
            </span>
            <br />
            <span class="break-line-style"
              >{{
                companyInfoDetail !== null
                  ? companyInfoDetail.employee_text
                  : ''
              }}
            </span>
          </li>
          <!--
          <li
            v-if="
              companyInfoDetail !== null &&
                companyInfoDetail.employee_men !== null
            "
          >
            <span class="title-bold">
              {{
                $t('company-detail.title.company-information.employee-men', {
                  split: '/'
                })
              }}:
            </span>
            {{
              companyInfoDetail !== null
                ? companyInfoDetail.employee_men +
                  ' ' +
                  $t(computedPerson(companyInfoDetail.employee_men), {
                    split: '/'
                  })
                : ''
            }}
          </li>

          <li
            v-if="
              companyInfoDetail !== null &&
                companyInfoDetail.employee_women !== null
            "
          >
            <span class="title-bold">
              {{
                $t('company-detail.title.company-information.employee-women', {
                  split: '/'
                })
              }}:
            </span>
            {{
              companyInfoDetail !== null
                ? companyInfoDetail.employee_women +
                  ' ' +
                  $t(computedPerson(companyInfoDetail.employee_women), {
                    split: '/'
                  })
                : ''
            }}
          </li>

          <li
            v-if="
              companyInfoDetail !== null &&
                companyInfoDetail.employee_viet !== null
            "
          >
            <span class="title-bold">
              {{
                $t('company-detail.title.company-information.employee-viet', {
                  split: '/'
                })
              }}:
            </span>
            {{
              companyInfoDetail !== null
                ? companyInfoDetail.employee_viet +
                  ' ' +
                  $t(computedPerson(companyInfoDetail.employee_viet), {
                    split: '/'
                  })
                : ''
            }}
          </li> -->

          <li
            v-if="
              companyInfoDetail !== null &&
              companyInfoDetail.office_location !== null
            "
          >
            <span class="title-bold"
              >{{
                $t('company-detail.title.company-information.office-location', {
                  split: '/'
                })
              }}:
            </span>
            <div
              class="td-right"
              v-html="
                companyInfoDetail !== null
                  ? companyInfoDetail.office_location
                  : ''
              "
            ></div>
          </li>

          <li
            class="mt-5"
            v-if="
              companyInfoDetail !== null && companyInfoDetail.homepage !== null
            "
          >
            <span class="title-bold">
              {{
                $t('company-detail.title.company-information.homepage', {
                  split: '/'
                })
              }}:
            </span>
            <a
              target="_blank"
              :href="
                companyInfoDetail !== null ? companyInfoDetail.homepage : ''
              "
            >
              {{ companyInfoDetail !== null ? companyInfoDetail.homepage : '' }}
            </a>
          </li>

          <li
            v-if="
              companyDetail !== null &&
              companyDetail.detail !== null &&
              companyDetail.detail.d_company !== null &&
              companyDetail.detail.d_company.sns_1
            "
          >
            <span class="title-bold">
              {{
                $t('company-detail.title.company-information.sns1', {
                  split: '/'
                })
              }}:
            </span>
            <a :href="companyInfoDetail.sns_1" target="_blank">
              {{ companyInfoDetail !== null ? companyInfoDetail.sns_1 : '' }}
            </a>
          </li>

          <li
            v-if="
              companyDetail !== null &&
              companyDetail.detail !== null &&
              companyDetail.detail.d_company !== null &&
              companyDetail.detail.d_company.sns_2
            "
          >
            <span class="title-bold">
              {{
                $t('company-detail.title.company-information.sns2', {
                  split: '/'
                })
              }}:
            </span>
            <a :href="companyInfoDetail.sns_2" target="_blank">
              {{ companyInfoDetail !== null ? companyInfoDetail.sns_2 : '' }}
            </a>
          </li>

          <li
            v-if="
              companyInfoDetail !== null &&
              companyInfoDetail.video_sharing_site !== null
            "
          >
            <span class="title-bold">
              {{
                $t('company-detail.title.company-information.other-url', {
                  split: '/'
                })
              }}:
            </span>
            <a
              target="_blank"
              :href="
                companyInfoDetail !== null
                  ? companyInfoDetail.video_sharing_site
                  : ''
              "
            >
              {{
                companyInfoDetail !== null
                  ? companyInfoDetail.video_sharing_site
                  : ''
              }}
            </a>
          </li>
          <br />
          <li
            v-if="
              companyInfoDetail !== null && companyInfoDetail.document !== null
            "
          >
            <span class="title-bold">
              {{
                $t(
                  'company-detail.title.company-information.download-document',
                  {
                    split: '/'
                  }
                )
              }}:
            </span>
            <a
              target="_blank"
              :href="
                companyInfoDetail !== null ? companyInfoDetail.document : ''
              "
            >
              {{
                $t('top-page.document-download', {
                  split: '/'
                })
              }}
            </a>
          </li>
        </ul>
      </div>
    </div>

    <youtube
      v-if="
        isLogVideo === true &&
        companyDetail !== null &&
        companyDetail.detail.d_company !== null &&
        companyDetail.detail.d_company.introduction_video !== '' &&
        companyDetail.detail.d_company.introduction_video !== null &&
        companyDetail.detail.d_company.introduction_video.includes(YOUTUBE_LINK)
      "
      :video-id="videoId"
      ref="youtube"
      @playing="playingVideo"
      @ended="endedVideo"
    ></youtube>

    <iframe
      id="iframe-video"
      ref="player"
      v-else
      :src="
        companyDetail !== null &&
        companyDetail.detail !== null &&
        companyDetail.detail.d_company !== null
          ? companyDetail.detail.d_company.introduction_video
          : ''
      "
      frameborder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
import { getIdFromUrl } from 'vue-youtube';
import {
  COMPANY_SCREEN_ID,
  PLAY_VIDEO,
  PLAYED_VIDEO,
  UNPLAYED_VIDEO,
  YOUTUBE_LINK
} from '@/common/constants';

export default {
  name: 'InformationOfCompany',

  props: {
    companyDetail: {
      type: Object
    },

    companyInfoDetail: {
      type: Object
    },

    isLogVideo: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    playingVideo() {
      console.log(111);
      if (this.videoStatus === UNPLAYED_VIDEO) {
        this.videoStatus = PLAYED_VIDEO;
        this.postApplicantLogAndOpen();
      }
    },

    postApplicantLogAndOpen() {
      // create log applicant
      const data = {
        exhibiting_company_id: this.companyDetail.companyInfo.id,
        screen_id: COMPANY_SCREEN_ID,
        action: PLAY_VIDEO
      };
      this.$store.dispatch('postApplicantLog', { data });
    },

    endedVideo() {
      console.log(222);
      this.videoStatus = UNPLAYED_VIDEO;
    }
  },

  created() {
    this.videoStatus = UNPLAYED_VIDEO;
    this.YOUTUBE_LINK = YOUTUBE_LINK;
  },

  computed: {
    videoId() {
      if (this.companyDetail && this.companyDetail.detail.d_company) {
        return getIdFromUrl(
          this.companyDetail.detail.d_company.introduction_video
        );
      } else {
        return '';
      }
    }
  }
};
</script>

<style lang="scss">
.break-line-style {
  white-space: pre-line;
}
</style>
